var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRAiSymbolGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_r_ai_symbol_gray_svg__clip0_15333_42819)",
    fill: "#8C8C8C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.873 21.67l-2.355-1.975h16.517L6.873 21.67zM9.555 18.21v-4.377h1.897l3.285 4.378h3.36l-3.97-5.284a4.876 4.876 0 002.05-3.967 4.873 4.873 0 00-4.871-4.868H6.873v14.116h2.682v.003zm0-11.436h1.75c1.206 0 2.19.98 2.19 2.186a2.195 2.195 0 01-2.19 2.189h-1.75V6.774zM18.662.885h.257l1.07 3.05h-1.327V.885zM15.107 3.935v-.26l3.048-1.068v1.328h-3.048zM18.155 7.487H17.9l-1.07-3.048h1.326v3.048zM21.712 4.44v.256l-3.05 1.07V4.44h3.05z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_r_ai_symbol_gray_svg__clip0_15333_42819"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}

export default SvgIconRAiSymbolGray;